/* SkinStyle coming soon: scroll reveal and photo drift. Runs only when html.ss-motion-on is set by the hero section. */
(function () {
  var d = document.documentElement;
  if (!d.classList.contains('ss-motion-on')) return;
  window.ssMotionReady = true;

  /* Reveal on scroll, staggered within each group */
  var SEL = '.ss-section__head > *, .ss-pillar, .ss-band__panel, .ss-cta--solo > div > *';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  function setup(root) {
    [].slice.call(root.querySelectorAll(SEL)).forEach(function (el) {
      var group = [].slice.call(el.parentNode.children).filter(function (s) { return s.matches(SEL); });
      el.style.setProperty('--ss-d', (group.indexOf(el) * 110) + 'ms');
      io.observe(el);
    });
  }
  setup(document);

  /* Photo motion: hero drifts vertically; wide photo slowly zooms out as it scrolls up the screen */
  var items = [];
  function collect() {
    items = [];
    var hero = document.querySelector('.ss-banner__media img');
    if (hero) items.push({ img: hero, box: hero.closest('.ss-banner__media'), axis: 'y', amt: 0.04 });
    var band = document.querySelector('.ss-band__media img');
    if (band) items.push({ img: band, box: band.closest('.ss-band__media'), axis: 'zoom', amt: 0.12 });
    return hero;
  }
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    items.forEach(function (p) {
      var r = p.box.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      c = Math.max(-1, Math.min(1, c));
      if (p.axis === 'zoom') {
        /* 1 + amt when entering at the bottom of the screen, 1.0 once past the middle */
        p.img.style.scale = (1 + p.amt * Math.max(0, c)).toFixed(4);
      } else {
        p.img.style.translate = '0 ' + (c * p.amt * r.height).toFixed(1) + 'px';
      }
    });
  }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  var hero = collect();
  update();
  if (hero) {
    var settle = function () { requestAnimationFrame(function () { d.classList.add('ss-hero-in'); }); };
    if (hero.complete) settle(); else { hero.addEventListener('load', settle); hero.addEventListener('error', settle); }
  } else {
    d.classList.add('ss-hero-in');
  }

  /* Theme editor: sections re-render in place, so show their content straight away */
  document.addEventListener('shopify:section:load', function (e) {
    [].slice.call(e.target.querySelectorAll(SEL)).forEach(function (el) { el.classList.add('is-in'); });
    collect(); d.classList.add('ss-hero-in'); update();
  });
})();
